<div class='flex-column justify-content-center align-items-center'>
	<div class='flex-column justify-content-center'>

		<!-- DELEGATION PRIMENG DATATABLE -->
		<p-table [value]='paginationResult.entities' [lazy]='true' (onLazyLoad)='loadData($event)'
			[rows]='paginationRequest.pageSize' [totalRecords]='paginationResult.filteredEntities'
			[rowsPerPageOptions]='[10,20,30,40,50]' [(selection)]='selectedEntities' [paginator]="true" [rows]="10"
			[rowHover]='true' [showCurrentPageReport]='true'
			currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}"
			class='custom-table' styleClass='p-datatable-striped' [loading]='false' [metaKeySelection]='true'
			selectionMode='multiple'>

			<!-- TABLE TITLE DEFINITION -->
			<ng-template pTemplate="caption">
				<div class="d-flex align-items-center justify-content-center text-uppercase mb-4 table-title">
					{{ 'administration.delegations.delegations' | translate }}
				</div>
			</ng-template>

			<!-- TABLE COLUMN DEFINITION -->
			<ng-template pTemplate='header'>
				<tr style='white-space:nowrap;'>
					<!-- SELECT -->
					<th class='checkbox-column'>
						<!-- EMPTY -->
					</th>
					<!-- NAME -->
					<th pSortableColumn='codename'>
						<div class="d-flex align-items-center h-100">
							<!-- COLUMN TITLE -->
							<div
								class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
								{{ 'administration.delegations.codename' | translate }}
							</div>
							<!-- COLUMN SORT && FILTER ICONS -->
							<div class="d-flex align-items-center h-100">
								<!-- COLUMN SORT -->
								<p-sortIcon field='codename'></p-sortIcon>
								<!-- COLUMN FILTER -->
								<p-columnFilter field='codename' type='text'
									placeholder="{{ 'general.search' | translate }}" display='menu'
									[showMatchModes]='false' [showOperator]='false'
									[showAddButton]='false'></p-columnFilter>
							</div>
						</div>
					</th>
					<!-- TYPE -->
					<th pSortableColumn='info'>
						<div class="d-flex align-items-center h-100">
							<!-- COLUMN TITLE -->
							<div
								class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
								{{ 'administration.delegations.info' | translate }}
							</div>
							<!-- COLUMN SORT && FILTER ICONS -->
							<div class="d-flex align-items-center h-100">
								<!-- COLUMN SORT -->
								<p-sortIcon field='info'></p-sortIcon>
								<!-- COLUMN FILTER -->
								<p-columnFilter field='info' type='text'
									placeholder="{{ 'general.search' | translate }}" display='menu'
									[showMatchModes]='false' [showOperator]='false'
									[showAddButton]='false'></p-columnFilter>
							</div>
						</div>
					</th>
			</ng-template>


			<ng-template pTemplate='header'>
				<tr>
					<!-- SELECT -->
					<th class='checkbox-column'>
						<!-- EMPTY -->
					</th>
					<!-- NAME -->
					<th pSortableColumn='codename'>
						<div class="d-flex align-items-center h-100">
							<!-- COLUMN TITLE -->
							<div
								class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
								{{ 'administration.delegations.codename' | translate }}
							</div>

							<!-- COLUMN SORT && FILTER ICONS -->
							<div class="d-flex align-items-center h-100">

								<!-- COLUMN SORT -->
								<p-sortIcon field='codename'></p-sortIcon>

								<!-- COLUMN FILTER -->
								<p-columnFilter field='codename' type='text'
									placeholder="{{ 'general.search' | translate }}" display='menu'
									[showMatchModes]='false' [showOperator]='false'
									[showAddButton]='false'></p-columnFilter>
							</div>
						</div>
					</th>
					<!-- TYPE -->
					<th pSortableColumn='info'>
						<div class="d-flex align-items-center h-100">

							<!-- COLUMN TITLE -->
							<div
								class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
								{{ 'administration.delegations.info' | translate }}
							</div>

							<!-- COLUMN SORT && FILTER ICONS -->
							<div class="d-flex align-items-center h-100">

								<!-- COLUMN SORT -->
								<p-sortIcon field='info'></p-sortIcon>

								<!-- COLUMN FILTER -->
								<p-columnFilter field='info' type='text'
									placeholder="{{ 'general.search' | translate }}" display='menu'
									[showMatchModes]='false' [showOperator]='false'
									[showAddButton]='false'></p-columnFilter>

							</div>

						</div>
					</th>

			</ng-template>

			<!-- TABLE DELEGATIONS-->
			<ng-template pTemplate="emptymessage">
				<tr>
					<td colspan="8" class="p-0">
						<div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message"
							i18n>
							{{ 'table.tableEmptyMessage' | translate }}!
						</div>
					</td>
				</tr>
			</ng-template>

			<ng-template pTemplate="body" let-delegation>

				<tr [ngClass]="{'custom-rows-small' : authenticationService?.user?.tableSize === 'SMALL'}"
					class="p-selectable-row custom-rows" (dblclick)="editDialog(delegation)">
					<td style="position: relative">
						<button type='button' class='absolute-cell-content btn custom-table-remove-button '
							(click)='deleteDelegation(delegation)'>
							<svg-icon src='../../../../../../assets/icons/trash.svg'
								class='d-flex flex-wrap custom-table-remove-button-icon'
								[svgStyle]="{ 'height.px': iconListHeight+4, 'width.px': iconListWidth+4 }"></svg-icon>
						</button>




					</td>
					<!-- CODE NAME-->
					<td>
						{{delegation.codename}}
					</td>

					<!-- info -->
					<td>
						{{delegation.info}}
					</td>
					<!-- ACTIVE -->
					<!--<td>
						<div class="d-flex justify-content-center align-items-center">
							<i class="pi"
								[ngClass]="{'true-icon pi-check-circle': !delegation.deleted, 'false-icon pi-times-circle': delegation.deleted}"></i>
						</div>
					</td> -->
				</tr>

			</ng-template>



			<!-- FOOTER -->
			<ng-template pTemplate="footer">
				<tr>
					<td colspan="8" class="p-0">
						<div class="d-flex flex-row align-items-center p-3 gap-3">
							<app-table-add-button app-table-add-button [text]="'Delegation'"
								(btnClick)="create()"></app-table-add-button>

							<!--	<button (click)="create()" type="button"
								class="btn custom-vehicle-panel-settings-button" data-bs-toggle="modal"
								data-bs-target="#DelegationForm">
								<svg-icon src="./../../../../../../assets/icons/plus.svg" class="d-flex flex-wrap"
									[svgStyle]="{ 'height.px': 25, 'width.px': 30}"></svg-icon>
							</button> -->
						</div>
					</td>
				</tr>
			</ng-template>

		</p-table>

	</div>
</div>
<p-confirmDialog [style]="{width: '50vw'}" baseZIndex='10000'
	header="{{ 'control-panel.delete-dialog.title' | translate }}" icon='pi pi-exclamation-triangle'></p-confirmDialog>

<!-- ROUTES FORM -->
<app-delegation-form></app-delegation-form>